import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MatomoProvider } from "react-matomo";
import matomoInstance from "./matomo"; // Chemin vers Matomo
import { HelmetProvider } from "react-helmet-async";

const rootElement = document.getElementById("root");

// Vérifier si le contenu SSR est présent (pour distinguer SSR vs développement)
// En SSR, le root contient au moins un élément enfant
// En développement (npm start), le root est vide
const hasSSRContent = rootElement && rootElement.children.length > 0 && rootElement.innerHTML.trim() !== '';

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <MatomoProvider value={matomoInstance}>
        <App />
      </MatomoProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Utilisation de hydrateRoot pour React 19 si SSR, sinon createRoot pour développement
if (hasSSRContent) {
  // Mode SSR : hydrater le contenu pré-rendu
  hydrateRoot(rootElement, app);
} else {
  // Mode développement sans SSR : créer une nouvelle racine
  const root = createRoot(rootElement);
  root.render(app);
}

// Mesurer la performance
reportWebVitals();
